import { useCreate, useDelete, useGetAll, useGetOne, useUpdate } from "./crudService";

const endpoint:string = 'ssas';

export function useGetAllSsas(params:{page:number}, queryParams:any = {}) {
    return useGetAll({queryKey: [endpoint], ...queryParams}, params);
}

export function useGetSsa(id: number, params:any = {}) {
    return useGetOne({queryKey: [endpoint, id], ...params});
}

export function useCreateSsa() {
    return useCreate({queryKey: [endpoint]});
}

export function useUpdateSsa({id}) {
    return useUpdate({queryKey: [endpoint, id]});
}

export function useDeleteSsa({id}) {
    return useDelete({queryKey: [endpoint, id]});
}
